export default {
  base_url: "https://preprod-apiv2.ignif.ai/api-platform",
};
